import React from "react";
// import styles from "./TextInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import { Form } from "react-bootstrap";
import {
  FieldProps,
  getFieldContainerStyle,
  hasRequiredValidation,
  hasValue,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface TextInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

const TextInput: React.FC<TextInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    placeholder,
    value,
    example,
    disabled,
    readOnly,
    isValid = true,
    error,
    show = true,
    selected,
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);
  const required = hasRequiredValidation(field);
  const isFilled = hasValue(field);
  return (
    <div style={containerStyle}>
      <LabeledInputWrapper
        field={{
          ...field,
          showEmitButton: !!field.emitOnButton,
          onEmitClick: () => handleChange(id, { manualEmit: true }),
        }}
      >
        <Form.Control
          id={id}
          type="text"
          value={value ?? ""}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete="off"
          onChange={(e) => handleChange(id, e)}
          onBlur={() => handleBlur(id)}
          onFocus={() => handleSelect(id)}
          isInvalid={!isValid}
          className={`${CommonStyles.customInput} ${
            selected ? CommonStyles.selectedField : ""
          } ${disabled || readOnly ? CommonStyles.disabledField : ""} ${
            required && !isFilled ? CommonStyles.requiredField : ""
          }`}
        />
        {!isValid && error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </LabeledInputWrapper>

      {example && <small className="text-muted">Example: {example}</small>}
    </div>
  );
};

export default TextInput;
